module.exports = __webpack_public_path__ + "img/barcelona.c5c90eac.jpg";